import { ArrowLeft, X } from 'lucide-react'

interface WidgetHeaderProps {
  title?: string
  onBack?: () => void
  onClose: () => void
}

export function WidgetHeader({ title, onBack, onClose }: WidgetHeaderProps) {
  return (
    <div className="flex items-center gap-2 px-4 py-3 border-b border-border flex-shrink-0">
      {onBack && (
        <button
          onClick={onBack}
          className="p-1.5 rounded-lg hover:bg-secondary transition-colors text-muted-foreground hover:text-foreground"
          aria-label="Go back"
        >
          <ArrowLeft className="w-4 h-4" />
        </button>
      )}
      {title && (
        <span className="text-sm font-semibold text-foreground flex-1">{title}</span>
      )}
      {!title && <span className="flex-1" />}
      <button
        onClick={onClose}
        className="p-1.5 rounded-lg hover:bg-secondary transition-colors text-muted-foreground hover:text-foreground ml-auto"
        aria-label="Close help"
      >
        <X className="w-4 h-4" />
      </button>
    </div>
  )
}
